import React from "react";

const Services = ({servicesRef}) => {
  return (
    <div ref={servicesRef}>
      <section id="services" className="services text-justify">
        <div className="container section-header" data-aos="fade-up">
          <h2>Services</h2>
          <p>
          "Elevate Your Conferences, Seamlessly Managed and Globally Engaged.
           Empowering Excellence in Virtual Experiences, Registration, Publishing, and Beyond!"
          </p>
        </div>

        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-6 " data-aos="fade-up" data-aos-delay="100">
              <div className="service-item d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-briefcase"></i>
                </div>
                <div>
                  <h4 className="title">
                  <a className="stretched-link">Virtual Conference Solutions</a>
                  </h4>
                  <p className="description">
                  Transform your conferences into immersive virtual or hybrid experiences. Our tailored software ensures seamless hosting for scientific conferences of any size, offering a dynamic and inclusive platform for attendees worldwide.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 " data-aos="fade-up" data-aos-delay="400">
              <div className="service-item d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-binoculars"></i>
                </div>
                <div>
                  <h4 className="title">
                    <a className="stretched-link">Dynamic Slide Publishing</a>
                  </h4>
                  <p className="description">
                  Introducing our Smart Slide platform, allowing authors to effortlessly publish their presentation slides. Users can access and download slides before and after the conference, facilitating the rapid dissemination of research results. Acquire valuable content in a short time for enhanced knowledge sharing.
                  </p>
                </div>
              </div>
            </div>



            <div className="col-lg-6 " data-aos="fade-up" data-aos-delay="300">
              <div className="service-item d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-bar-chart"></i>
                </div>
                <div>
                  <h4 className="title">
                    <a className="stretched-link">Efficient Registration Services</a>
                  </h4>
                  <p className="description">
                  Simplify attendee registration with our custom registration forms. We create user-friendly forms to support seamless registration processes, enabling you to accept online payments in 14 currencies. Authors and reviewers can register using the same platform they used for submission and review
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 " data-aos="fade-up" data-aos-delay="600">
              <div className="service-item d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-calendar4-week"></i>
                </div>
                <div>
                  <h4 className="title">
                    <a className="stretched-link">Integrated Publishing Services</a>
                  </h4>
                  <p className="description">
                  Elevate your publication process with our integrated publishing services. Covering diverse fields from computing to environmental sciences, we provide fast and flexible publication of proceedings and collections across various scientific domains. Seamlessly transition from submission to publication of peer-reviewed content for a streamlined scholarly experience.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-6 " data-aos="fade-up" data-aos-delay="200">
              <div className="service-item d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-card-checklist"></i>
                </div>
                <div>
                  <h4 className="title">
                    <a className="stretched-link">Comprehensive Conference Management</a>
                  </h4>
                  <p className="description">
                  Our conference management system handles everything from program committee coordination to publishing proceedings.
                  </p>
                </div>
              </div>
            </div>



            <div className="col-lg-6 " data-aos="fade-up" data-aos-delay="500">
              <div className="service-item d-flex">
                <div className="icon flex-shrink-0">
                  <i className="bi bi-brightness-high"></i>
                </div>
                <div>
                  <h4 className="title">
                    <a className="stretched-link">Strategic Call for Participation</a>
                  </h4>
                  <p className="description">
                  Amplify your conference reach with our strategic Call for Participation (CFP) services. Within minutes, publish your conference details and connect with our users.
                  </p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
